// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--gR7ja";
export var c_video_block = "styles-module--c_video_block---6CG2";
export var video_wrapper = "styles-module--video_wrapper--Ncwju";